<template>
  <v-container>
    <h1>Onboarding User Data</h1>
    <br>
    <v-card>
      <v-card-title class="blue">
        <span class="headline white--text">Details</span>
        <v-spacer />
        <template v-for="brand in Object.keys(onboardingStatus)">
          <v-badge
            v-if="isLoadUser && onboardingStatus && (brand=='USER'||brand=='PROPVEST')"
            :key="brand"
          >
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <div
                  round
                  v-on="on"
                >
                  <v-chip
                    v-if="onboardingStatus[brand].valid"
                    color="teal"
                    text-color="white"
                  >
                    <v-avatar>
                      <v-icon>check_circle</v-icon>
                    </v-avatar>
                    <template v-if="brand=='USER'">
                      EXPORO
                    </template>
                    <template v-else>
                      {{ brand }}
                    </template>
                  </v-chip>
                  <v-chip
                    v-else
                    color="red"
                    text-color="white"
                  >
                    <v-avatar>
                      <v-icon>cancel</v-icon>
                    </v-avatar>
                    <template v-if="brand=='USER'">
                      EXPORO
                    </template>
                    <template v-else>
                      {{ brand }}
                    </template>
                  </v-chip>
                </div>
              </template>
              <div>
                <p> Onboarding valid: {{ onboardingStatus[brand].valid }} </p>
                <p
                  v-for="key in Object.keys(onboardingStatus[brand].components)"
                  :key="key"
                >
                  {{ key }} : {{ onboardingStatus[brand].components[key] }}
                </p>
              </div>
            </v-tooltip>
          </v-badge>
        </template>
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-alert
          v-if="error"
          :value="error"
          type="error"
          color="error"
        >
          {{ error }}
        </v-alert>
        <user-detail-component
          v-if="isLoadUser && user"
          :user="user"
          :legal-user="legalUser"
          :cognito-user="cognitoUser"
          :cognito-user-pool-data="cognitoUserPoolData"
          :terms-and-conditions-data="termsAndConditionsData"
          :on-change-user="onChangeUser"
          :get-data="_getOnboardingUserById"
        />
        <v-layout
          v-if="!isLoadUser"
          justify-center
        >
          <div class="my-3">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { OnboardingUserDetailComponent } from '@/components/users';

export default {
  name: 'OnboardingUserDetails',
  components: {
    'user-detail-component': OnboardingUserDetailComponent,
  },
  data() {
    return {
      user: null,
      legalUser: null,
      isLoadUser: false,
      cognitoUserPoolData: null,
      termsAndConditionsData: null,
      error: null,
      onboardingStatus: {},
    };
  },
  async mounted() {
    await this._getOnboardingUserById();
  },
  methods: {
    ...mapActions(['getOnboardingUserById']),
    async _getOnboardingUserById() {
      this.isLoadUser = false;
      try {
        this.error = null;
        const response = await this.getOnboardingUserById(this.$route.params.id);

        this.onboardingStatus = _.get(response, 'onboardingStatus') || {};

        this.user = _.get(response, 'userMetaData.data.naturalUser') || {};

        this.legalUser = _.get(response, 'userMetaData.data.legalUser') || {};

        if (
          !this.user &&
          response.cognitoUserPoolData &&
          response.congnitoUserData
        ) {
          throw new Error('No user found');
        }
        this.user.id = this.$route.params.id;
        this.cognitoUser = response.congnitoUserData || {};
        this.cognitoUser.id = this.$route.params.id;
        this.cognitoUserPoolData = response.cognitoUserPoolData || {};
        this.cognitoUserPoolData.id = this.$route.params.id;
        this.termsAndConditionsData = response.termsAndConditionsData || {};
        this.termsAndConditionsData.id = this.$route.params.id;
        this.isLoadUser = true;
      } catch (error) {
        console.error(error);
        this.error = `Error getting user info ${this.$route.params.id}`;
        this.user = null;
        this.cognitoUser = {};
        this.cognitoUserPoolData = {};
        this.termsAndConditionsData = {};
        this.isLoadUser = true;
      }
    },
    async onChangeUser(data) {
      this.user[data.name] = _.isObjectLike(this.user[data.name])
        ? { ...this.user[data.name], ...data.value }
        : data.value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/onboardingUsers/UserDetail.vue